<template>
  <div v-loading="loading" class="content-container">
    <search-comp @onSearch="getList" @onReset="onReset">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Mã đặt phòng</div>
                <div class="child-w-80">
                  <!-- v-model="searchParams.roomNumber" -->
                  <!-- :disabled="searchParams.dateFrom" -->
                  <input
                    v-model="searchParams.bookingCode"
                    type="text"
                    @keypress="clsAlphaNoOnly"
                  />
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Khách sạn</div>
                <div class="child-w-80">
                  <!-- <select v-model="searchParams.hotelId">
                    <option value=""></option>
                    <option
                      v-for="(hotel, index) in hotelList"
                      :key="index"
                      :value="hotel.id"
                      :label="hotel.name"
                    ></option>
                  </select> -->
                  <el-select
                    v-model="searchParams.hotelId"
                    :disabled="disabledDate"
                    collapse-tags
                    multiple
                  >
                    <el-option
                      v-for="(hotel, index) in hotelList"
                      :key="index"
                      :value="hotel.id"
                      :label="hotel.name"
                    />
                  </el-select>
                </div>
              </div>
            </div>
            <div class="das-form-col col-6">
              <div class="das-form-input">
                <div class="label">Ngày</div>
                <div class="child-w-80">
                  <CalendarRange
                    v-model="datetimeRange"
                    :disabled="disabledDate"
                    style="display: block; width: 500px"
                    :min-max="{
                      min: this.$moment().format('YYYY-MM-DD')
                    }"
                    mode="date"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>
    <div class="content-box">
      <div class="section-box outline">
        <div class="das-form-container">
          <div class="das-form-title-container justify-space-between">
            <div class="das-form-title">
              <span class="main-title">Báo cáo dự kiến</span>
            </div>
            <div class="button-containers-title">
              <InfoBtn @click="dialogFormVisible = true" />
              <el-dropdown trigger="click" @command="handleCommand">
                <button class="btn medium primary outline download-button">
                  <i class="el-icon-download"></i>
                </button>
                <el-dropdown-menu>
                  <el-dropdown-item command="pdf">Xuất PDF</el-dropdown-item>
                  <el-dropdown-item command="excel"
                    >Xuất Excel</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <button class="btn primary small">Xuất Excel</button> -->
            </div>
            <!-- <button class="btn medium primary outline">Thêm</button> -->
          </div>
          <hr />
          <div class="w-full">
            <el-table
              class="report-table overflow-auto"
              :height="'700px'"
              :data="rows"
              :border="true"
              :span-method="objectSpanMethod"
            >
              <el-table-column
                v-for="(item, index) in columns"
                :key="index"
                :prop="item.field"
                :label="item.headerName"
                :min-width="item?.minWidth || 100"
                :header-align="'left'"
                :align="item.cellClass === 'ag-cell-right' ? 'right' : null"
              >
              </el-table-column>
            </el-table>
          </div>
          <div class="daily-trans__item-footer">
            <span>
              {{ 'Tổng số lượng khách' }}: {{ $displayCurrency(numOfGuest) }}
            </span>
            <span style="padding-left: 20px">
              {{ 'Tổng số phòng' }}:
              {{ $displayCurrency(numOfRoom) }}
            </span>
          </div>
          <!-- <div class="grid-scroll mt-10">
            <GridVx
              ref="agGrid"
              :columns="columns"
              :rows="rows"
              class="agGrid"
              dom-layout="scroll"
              :header-height-setter="headerHeightSetter"
              :is-header-height-setter="true"
              :default-col-def="defaultColDef"
              :auto-size-cell="true"
              :auto-select-first-row="false"
              row-selection="false"
            />
          </div> -->
        </div>
      </div>
    </div>

    <el-dialog
      title="Chú thích"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <ul class="annotate-container">
            <li>STT: số thứ tự</li>
            <li>Recode: Mã đặt phòng</li>
            <li>
              Ngày CI: Ngày Check in dự kiến của đặt phòng: Format: DDMMYYYY
            </li>
            <li>
              Ngày CO: Ngày check out dự kiến của đặt phòng. Format: DDMMYYYY
            </li>
            <li>Nguồn: Nguồn của đặt phòng</li>
            <li>Số lượng khách: Tổng cả người lớn và trẻ em trong đặt phòng</li>
            <li>Ghi chú: ghi chú của đặt phòng</li>
          </ul>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button class="btn primary small" @click="dialogFormVisible = false">
            {{ $t('button.cancel') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import CalendarRange from '@/components/CalendarSelect/CalendarRange.vue'
import InfoBtn from './components/InfoBtn.vue'
import { getAllHotel } from '@/api/hotel'
import {
  getBookingIncomingApi,
  getBookingIncomingExcel
} from '@/api/report_service/report_b'

export default {
  components: {
    CalendarRange,
    InfoBtn
  },
  data() {
    return {
      disabledDate: false,
      defaultColDef: {
        flex: 1,
        // resizable: true,
        // sortable: true,
        wrapText: true,
        autoHeight: true,
        suppressMovable: true,
        headerComponentParams: {
          template:
            '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            // '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
            // '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
            // '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
            // '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
            '    <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: normal;"></span>' +
            // '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
            '</div>'
        }
      },
      dialogFormVisible: false,
      loading: false,
      hotelList: [],
      searchParams: {
        dateFrom: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().format('YYYY-MM-DD'),
        bookingCode: null,
        hotelId: []
      },
      searchParamsDefault: {
        dateFrom: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().format('YYYY-MM-DD'),
        bookingCode: null,
        hotelId: []
      },
      columns: [
        {
          headerName: this.$t('grid.column.order1'),
          field: 'no',
          headerTooltip: this.$t('grid.column.order1'),
          // tooltipField: 'no',
          sortable: false,
          minWidth: 60,
          maxWidth: 60
        },
        {
          headerName: this.$t('grid.column.bookingCode'),
          field: 'booking_code',
          headerTooltip: this.$t('grid.column.bookingCode'),
          tooltipField: 'booking_code',
          // width: 100,
          minWidth: 130,
          maxWidth: 150,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.roomLevel'),
          field: 'room_level_name',
          headerTooltip: this.$t('grid.column.roomLevel'),
          tooltipField: 'room_level_name',
          // width: 100,
          minWidth: 130,
          maxWidth: 150,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.numRoom'),
          field: 'num_of_room',
          headerTooltip: this.$t('grid.column.numRoom'),
          tooltipField: 'num_of_room',
          // width: 100,
          minWidth: 130,
          maxWidth: 150,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.CIDate'),
          field: 'ci_date',
          tooltipField: 'ci_date',
          sortable: false,
          minWidth: 120,
          maxWidth: 160
        },
        {
          headerName: this.$t('grid.column.CODate'),
          field: 'co_date',
          tooltipField: 'co_date',
          sortable: false,
          minWidth: 120,
          maxWidth: 160
        },
        {
          headerName: this.$t('grid.column.source'),
          field: 'source_name',
          tooltipField: 'source_name',
          sortable: false,
          minWidth: 150
        },
        {
          headerName: this.$t('grid.column.numGuest'),
          field: 'num_of_guest',
          headerTooltip: this.$t('grid.column.numGuest'),
          tooltipField: 'num_of_guest',
          sortable: false,
          minWidth: 100,
          maxWidth: 100
        },
        {
          headerName: this.$t('grid.column.salesEmployees'),
          field: 'salesman',
          headerTooltip: this.$t('grid.column.salesEmployees'),
          tooltipField: 'salesman',
          sortable: false,
          flex: 1,
          minWidth: 120
        }
      ],
      rows: [],
      numOfRoom: null,
      numOfGuest: null
    }
  },
  computed: {
    datetimeRange: {
      get() {
        return {
          start: this.searchParams.dateFrom,
          end: this.searchParams.dateTo
        }
      },
      set(val) {
        this.searchParams.dateFrom = val.start
        this.searchParams.dateTo = val.end
      }
    },
    recode() {
      return this.searchParams.bookingCode
    }
  },
  watch: {
    recode: {
      handler(val) {
        // console.log(val, 'newwwwwwwwwwww')
        if (val) {
          this.disabledDate = true
          this.datetimeRange = {
            start: null,
            end: null
          }
          this.searchParams.dateFrom = null
          this.searchParams.dateTo = null
          this.searchParams.hotelId = []
        } else {
          this.disabledDate = false
          this.datetimeRange = {
            start: this.$moment().format('YYYY-MM-DD'),
            end: this.$moment().format('YYYY-MM-DD')
          }
          this.searchParams.dateFrom = this.$moment().format('YYYY-MM-DD')
          this.searchParams.dateTo = this.$moment().format('YYYY-MM-DD')
        }
      },
      deep: true
    }
  },
  async mounted() {
    await this.getListHotel()

    this.getList()
  },
  methods: {
    objectSpanMethod(data) {
      // 0 1 6 8 // 2
      if (
        data.columnIndex <= 1 ||
        data.columnIndex === 6 ||
        data.columnIndex === 8
      ) {
        if (data.row.rowSpan !== null) {
          return {
            rowspan: data.row.rowSpan,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      } else if (data.columnIndex === 2) {
        if (data.row.rowSpan1 !== null) {
          return {
            rowspan: data.row.rowSpan1,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },
    clsAlphaNoOnly(e) {
      // Accept only alpha numerics, no special characters
      const regex = new RegExp('^[a-zA-Z0-9 ]+$')
      const str = String.fromCharCode(!e.charCode ? e.which : e.charCode)
      if (regex.test(str)) {
        return true
      }

      e.preventDefault()
      return false
    },
    handleCommand(cmmd) {
      if (cmmd === 'excel') {
        getBookingIncomingExcel(this.searchParams).then(res => {
          if (res) {
            const date = this.$moment().format('DD-MM-YYYY')
            const href = URL.createObjectURL(res)
            // create "a" HTML element with href to file & click
            const link = document.createElement('a')
            link.href = href
            link.setAttribute(
              'download',
              'expect_report_' + date + '.xlsx'
              // res.headers['content-disposition'].split('filename=')[1],
            ) // or any other extension
            document.body.appendChild(link)
            link.click()
            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link)
            URL.revokeObjectURL(href)
          } else {
            throw new Error(res)
          }
        })
      }
    },
    headerHeightGetter() {
      var columnHeaderTexts = [
        ...document.querySelectorAll('.ag-header-cell-text')
      ]
      var clientHeights = columnHeaderTexts.map(
        headerText => headerText.clientHeight
      )
      var tallestHeaderTextHeight = Math.max(...clientHeights)

      return tallestHeaderTextHeight
    },
    headerHeightSetter() {
      var padding = 30

      var height = this.headerHeightGetter() / 2 + padding
      this.$refs.agGrid.gridApi.setHeaderHeight(height)
      this.$refs.agGrid.gridApi.resetRowHeights()
    },
    async getListHotel() {
      const data = await getAllHotel()
      this.hotelList = data.data
    },
    async getList() {
      this.loading = true
      await getBookingIncomingApi(this.searchParams)
        .then(res => {
          const data = res?.data
          this.numOfGuest = res.page_size
          this.numOfRoom = res.page_num
          this.rows = []
          data.map((item, index) => {
            // console.log('ledoan', item)
            item.info_list.map((item1, index1) => {
              item1.sub_room_booking_incoming_list.map((item2, index2) => {
                if (index1 === 0) {
                  if (index2 === 0) {
                    const rowSpan = item.info_list.reduce((a, b) => {
                      return (a += b.sub_room_booking_incoming_list.length)
                    }, 0)
                    this.rows.push({
                      ...item2,
                      no: index + 1,
                      room_level_name: item1.room_level_name,
                      booking_code: item.booking_code,
                      salesman: item.salesman,
                      source_name: item.source_name,
                      rowSpan: rowSpan,
                      rowSpan1:
                        index2 === 0
                          ? item1.sub_room_booking_incoming_list.length
                          : null
                    })
                  } else {
                    this.rows.push({
                      ...item2,
                      no: index + 1,
                      room_level_name: item1.room_level_name,
                      booking_code: item.booking_code,
                      salesman: item.salesman,
                      source_name: item.source_name,
                      rowSpan: null,
                      rowSpan1:
                        index2 === 0
                          ? item1.sub_room_booking_incoming_list.length
                          : null
                    })
                  }
                } else {
                  this.rows.push({
                    ...item2,
                    no: index + 1,
                    room_level_name: item1.room_level_name,
                    booking_code: item.booking_code,
                    salesman: item.salesman,
                    source_name: item.source_name,
                    rowSpan: null,
                    rowSpan1:
                      index2 === 0
                        ? item1.sub_room_booking_incoming_list.length
                        : null
                  })
                }
              })
            })
          })
        })
        .catch(error => {
          console.log('ledoan', error)
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + error?.response.data?.message)
          })
        })
        .finally(() => {
          this.loading = false
          // this.fnSearchGroupList()
        })
    },
    async onReset() {
      this.searchParams = Object.assign({}, this.searchParamsDefault)
      await this.getList()
    }
  }
}
</script>

<style lang="scss">
.daily-trans__item-footer {
  height: 34px;
  line-height: 34px;
  padding: 0 12px;
  background-color: #e7f6e5 !important;
  border-bottom: 1px solid var(--cell-border);
  margin-bottom: 2px;
  font-weight: 500;
  font-size: 14px;
}
</style>
